import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateTaskInProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 500,
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M269.4 492.2C394.934 492.2 496.7 390.434 496.7 264.9C496.7 139.366 394.934 37.6001 269.4 37.6001C143.866 37.6001 42.1001 139.366 42.1001 264.9C42.1001 390.434 143.866 492.2 269.4 492.2Z",
			fill: "#EEF5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.4 48.7999C314.8 46.9999 323.9 53.0999 325.7 62.4999L380.1 342.4C381.9 351.8 375.8 360.9 366.4 362.7L177.3 399.5C167.9 401.3 158.8 395.2 157 385.8L102.6 105.9C100.8 96.4999 106.9 87.3999 116.3 85.5999L305.4 48.7999ZM301.9 30.5999L112.8 67.3999C93.3998 71.1999 80.6998 89.9999 84.4998 109.4L138.9 389.3C142.7 408.7 161.5 421.4 180.9 417.6L370 380.8C389.4 377 402.1 358.2 398.3 338.8L343.9 58.8999C340.1 39.4999 321.3 26.7999 301.9 30.5999Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.4 48.8001C314.8 47.0001 323.9 53.1001 325.7 62.5001L380.1 342.4C381.9 351.8 375.8 360.9 366.4 362.7L177.3 399.5C167.9 401.3 158.8 395.2 157 385.8L102.6 105.9C100.8 96.5001 106.9 87.4001 116.3 85.6001L305.4 48.8001Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.3 237.4L180.6 242.3L190.9 227",
			stroke: "white",
			strokeWidth: 5.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.1 124L249.1 115.8",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.6 146.9L302.7 129.2",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.6 146L162.5 151.3L174.4 133.5",
			stroke: "#E0EEFE",
			strokeWidth: 5.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.5 168.8C178.583 168.8 190 157.383 190 143.3C190 129.217 178.583 117.8 164.5 117.8C150.417 117.8 139 129.217 139 143.3C139 157.383 150.417 168.8 164.5 168.8Z",
			stroke: "#E0EEFE",
			strokeWidth: 7,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 214.2L266.8 206.1",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.2 237.2L320.4 219.5",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.1 260.1C196.183 260.1 207.6 248.683 207.6 234.6C207.6 220.517 196.183 209.1 182.1 209.1C168.017 209.1 156.6 220.517 156.6 234.6C156.6 248.683 168.017 260.1 182.1 260.1Z",
			stroke: "#E0EEFE",
			strokeWidth: 7,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.4 307.4L286.4 299.2",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.9 330.4L340 312.6",
			stroke: "#E0EEFE",
			strokeWidth: 7.1,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.8 352.9C215.883 352.9 227.3 341.483 227.3 327.4C227.3 313.317 215.883 301.9 201.8 301.9C187.717 301.9 176.3 313.317 176.3 327.4C176.3 341.483 187.717 352.9 201.8 352.9Z",
			stroke: "#E0EEFE",
			strokeWidth: 7,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.2 333.1C428.706 333.1 458.3 303.506 458.3 267C458.3 230.494 428.706 200.9 392.2 200.9C355.694 200.9 326.1 230.494 326.1 267C326.1 303.506 355.694 333.1 392.2 333.1Z",
			fill: "#76AFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.9 32.7999C205.981 32.7999 210.1 28.6809 210.1 23.5999C210.1 18.5189 205.981 14.3999 200.9 14.3999C195.819 14.3999 191.7 18.5189 191.7 23.5999C191.7 28.6809 195.819 32.7999 200.9 32.7999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.1 43.6002L235 31.4002C255.2 27.5002 274.7 40.7002 278.6 60.9002L279.2 64.2002C279.9 67.9002 277.5 71.5002 273.8 72.2002L151.3 95.9002C147.6 96.6002 144 94.2002 143.3 90.5002L142.7 87.2002C138.8 67.0002 152 47.5002 172.2 43.6002H172.1Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.9 8.20022C210.5 5.80022 222.6 14.0002 225.1 26.6002L227.5 39.2002L182 48.0002L179.6 35.4002C177.2 22.8002 185.4 10.7002 198 8.20022H197.9Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2046_441227",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 142,
			y: 30,
			width: 138,
			height: 67,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M172.1 43.6002L235 31.4002C255.2 27.5002 274.7 40.7002 278.6 60.9002L279.2 64.2002C279.9 67.9002 277.5 71.5002 273.8 72.2002L151.3 95.9002C147.6 96.6002 144 94.2002 143.3 90.5002L142.7 87.2002C138.8 67.0002 152 47.5002 172.2 43.6002H172.1Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2046_441227)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M287.094 59.1251L134.353 88.8149L137.138 103.147L289.88 73.4568L287.094 59.1251Z",
				fill: "#FFBA00"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M415.2 235.7C419.9 239.4 423.8 244.3 426.5 250.1C435.8 270.1 427.2 293.8 407.2 303.2C387.2 312.6 363.5 303.9 354.1 283.9",
			stroke: "#EDF4FF",
			strokeWidth: 11.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M373.4 230.8C381.7 226.9 390.7 226.1 399 228",
			stroke: "#EDF4FF",
			strokeWidth: 11.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M354.3 249.8C355.6 247.2 357.1 244.6 358.9 242.3",
			stroke: "#4895FC",
			strokeWidth: 11.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.3 371.3C107.381 371.3 111.5 367.181 111.5 362.1C111.5 357.019 107.381 352.9 102.3 352.9C97.2191 352.9 93.1001 357.019 93.1001 362.1C93.1001 367.181 97.2191 371.3 102.3 371.3Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M423.1 181.1C430.114 181.1 435.8 175.414 435.8 168.4C435.8 161.386 430.114 155.7 423.1 155.7C416.086 155.7 410.4 161.386 410.4 168.4C410.4 175.414 416.086 181.1 423.1 181.1Z",
			fill: "#E0EEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.1999 111.1C54.6123 111.1 58.9999 106.712 58.9999 101.3C58.9999 95.8876 54.6123 91.5 49.1999 91.5C43.7875 91.5 39.3999 95.8876 39.3999 101.3C39.3999 106.712 43.7875 111.1 49.1999 111.1Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M371.1 42.0002C380.986 42.0002 389 33.9861 389 24.1002C389 14.2143 380.986 6.2002 371.1 6.2002C361.214 6.2002 353.2 14.2143 353.2 24.1002C353.2 33.9861 361.214 42.0002 371.1 42.0002Z",
			fill: "#A8CCFF"
		})
	]
});
export default SvgEmptyStateTaskInProgress;
